import { render, staticRenderFns } from "./InvoiceApiTab.vue?vue&type=template&id=5c5c0a00&scoped=true"
import script from "./InvoiceApiTab.vue?vue&type=script&lang=js"
export * from "./InvoiceApiTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceApiTab.vue?vue&type=style&index=0&id=5c5c0a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c0a00",
  null
  
)

export default component.exports